import System from '@/modules/sys/router';
import User from '@/modules/user/router';
import Dev from '@/modules/dev/router';

export default [
  ...System,
  ...User,
  ...Dev,
];
